<template>
	<div
		id="sideBar"
		v-if="
			(this.$store.state.isLoggedIn &&
				this.$store.state.role === 'superAdmin') ||
				(this.$store.state.isLoggedIn && this.$store.state.role === 'gerente')
		"
		class="z-50 flex fixed"
		:class="!sideMenu ? '' : 'w-1/5'"
	>
		<div
			class="w-12 pt-3 fixed"
			:class="!sideMenu ? 'block sticky top-0 h-screen' : 'hidden'"
		>
			<button class="" @click="sideMenu = true">
				<arrow class="w-6 h-6" />
			</button>
		</div>
		<transition name="menu-side-bar">
			<div
				v-if="sideMenu"
				class="sticky top-0 h-screen block border border-black bg-white overflow-y-auto w-72"
			>
				<div class="mt-4 mb-5 flex items-center">
					<svg
						class="fill-current text-white rounded-full bg-gray-400 w-16 h-16 pt-1 inline-flex ml-6"
						version="1.1"
						id="Capa_1"
						xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink"
						x="0px"
						y="0px"
						viewBox="0 0 512 512"
						style="enable-background: new 0 0 512 512"
						xml:space="preserve"
					>
						<path
							d="M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148 C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962 c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216 h40C512,443.62,485.371,379.333,437.02,330.98z M256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40 c59.551,0,108,48.448,108,108S315.551,256,256,256z"
						/>
					</svg>
					<span class="ml-4 center"> <b>Gerente</b></span>
					<button class="ml-10 -mt-10" @click="sideMenu = false">
						<close class="w-10 h-10" />
					</button>
				</div>
				<!-----------------------------------PROVEEDORES----------------------------------------------------------->
				<div
					class="flex items-center justify-center mt-3 w-64 hover:bg-gray-500 hover:bg-opacity-25"
				>
					<router-link
						active-class="bg-gray-500 bg-opacity-25 opacity-100"
						to="/proveedores"
						><div class="w-64 px-8">
							<div
								class="bg-center border-b border-black pb-0 w-48 flex items-center opacity-75 hover:opacity-100"
							>
								<svg
									class="fill-current text-black w-10 h-12 mb-2"
									version="1.1"
									id="Capa_1"
									xmlns="http://www.w3.org/2000/svg"
									xmlns:xlink="http://www.w3.org/1999/xlink"
									x="0px"
									y="0px"
									viewBox="0 0 477.867 477.867"
									style="enable-background: new 0 0 477.867 477.867"
									xml:space="preserve"
								>
									<path
										d="M476.996,114.074l-34.133-102.4C440.541,4.701,434.016-0.002,426.667,0H51.2c-7.349-0.002-13.874,4.701-16.196,11.674 L0.87,114.074c-0.526,1.594-0.82,3.255-0.87,4.932c0,0.171,0,0.29,0,0.461v17.067c0.062,26.74,12.707,51.892,34.133,67.891 c0,0.137,0,0.239,0,0.375v221.867c0,28.277,22.923,51.2,51.2,51.2h307.2c28.277,0,51.2-22.923,51.2-51.2V204.8 c0-0.137,0-0.239,0-0.375c21.426-15.999,34.072-41.151,34.133-67.891v-17.067c0-0.171,0-0.29,0-0.461 C477.816,117.328,477.523,115.667,476.996,114.074z M358.4,34.133h55.962l22.767,68.267H358.4V34.133z M256,34.133h68.267V102.4 H256V34.133z M153.6,34.133h68.267V102.4H153.6V34.133z M63.505,34.133h55.962V102.4H40.738L63.505,34.133z M273.067,443.733 H204.8V307.2h68.267V443.733z M409.6,426.667c0,9.426-7.641,17.067-17.067,17.067H307.2v-153.6 c0-9.426-7.641-17.067-17.067-17.067h-102.4c-9.426,0-17.067,7.641-17.067,17.067v153.6H85.333 c-9.426,0-17.067-7.641-17.067-17.067V220.16c23.951,4.917,48.857-0.799,68.267-15.667c30.466,22.376,71.934,22.376,102.4,0 c30.466,22.376,71.934,22.376,102.4,0c19.41,14.869,44.316,20.584,68.267,15.667V426.667z M392.533,187.733 c-14.759-0.009-28.774-6.483-38.349-17.715c-6.202-7.097-16.984-7.823-24.081-1.621c-0.576,0.503-1.118,1.045-1.621,1.621 c-18.977,21.18-51.529,22.965-72.709,3.989c-1.401-1.256-2.733-2.587-3.989-3.989c-6.679-7.097-17.847-7.437-24.945-0.757 c-0.26,0.245-0.513,0.497-0.757,0.757c-18.976,21.18-51.529,22.965-72.709,3.989c-1.402-1.256-2.733-2.587-3.989-3.989 c-6.679-7.097-17.848-7.437-24.945-0.757c-0.26,0.245-0.513,0.497-0.757,0.757c-9.575,11.232-23.589,17.706-38.349,17.715 c-28.277,0-51.2-22.923-51.2-51.2h409.6C443.733,164.81,420.81,187.733,392.533,187.733z"
									/>
								</svg>
								<span class="ml-8 mt-4"><b>Proveedores</b></span>
							</div>
						</div>
					</router-link>
				</div>
				<!-----------------------------------VENDEDORES------------------------------------------------------------>
				<div
					class="flex items-center justify-center mt-3 w-64 hover:bg-gray-500 hover:bg-opacity-25"
				>
					<router-link
						active-class="bg-gray-500 bg-opacity-25 opacity-100"
						to="/vendedores"
						><div class="w-64 px-8">
							<div
								class="bg-center border-b border-black pb-0 w-48 flex items-center opacity-75 hover:opacity-100"
							>
								<svg
									class="fill-current text-black h-12 mb-2 -ml-8 mr-5"
									version="1.1"
									id="Layer_1"
									xmlns="http://www.w3.org/2000/svg"
									xmlns:xlink="http://www.w3.org/1999/xlink"
									x="0px"
									y="0px"
									viewBox="0 220 512 40"
									style="enable-background: new 0 0 512 512"
									xml:space="preserve"
								>
									<g id="_13-car">
										<g id="linear_color">
											<circle cx="242.8" cy="291.1" r="8.2" />
											<circle cx="438.4" cy="291.1" r="8.2" />
											<path
												d="M485.5,226.6l-60-9.1l-57.5-47.3c-5.4-4.4-12.1-6.8-19-6.8h-79.6c-9.1,0-17.7,4.1-23.3,11.2l-34.5,43.1h-23.2 c-13.5,0-24.4,11-24.5,24.5v27.2c0,16.5,13.4,29.9,29.9,29.9h14.5c4.5,19,23.5,30.7,42.5,26.2c13-3.1,23.1-13.2,26.2-26.2H404 c4.5,19,23.5,30.7,42.5,26.2c13-3.1,23.1-13.2,26.2-26.2h9.1c13.5,0,24.4-11,24.5-24.5v-24C506.4,238.7,497.5,228.4,485.5,226.6z M357.7,182.8l42.5,34.9h-78.6v-38h27.5C352.2,179.7,355.3,180.8,357.7,182.8z M258.9,184.8c2.6-3.2,6.5-5.1,10.6-5.1h3.1v38 h-40.1L258.9,184.8z M242.8,310.1c-10.5,0-19-8.5-19-19s8.5-19,19-19c10.5,0,19,8.5,19,19C261.8,301.6,253.3,310.1,242.8,310.1z M438.4,310.1c-10.5,0-19-8.5-19-19s8.5-19,19-19s19,8.5,19,19C457.4,301.6,448.9,310.1,438.4,310.1z M490,274.8 c0,4.5-3.7,8.1-8.2,8.2h-9.1c-4.5-19-23.5-30.7-42.5-26.2c-13,3.1-23.1,13.2-26.2,26.2H277.1c-4.5-19-23.5-30.7-42.5-26.2 c-13,3.1-23.1,13.2-26.2,26.2h-14.5c-7.5,0-13.6-6.1-13.6-13.6v-27.2c0-4.5,3.7-8.1,8.2-8.2h92.4c4.5,0,8.2-3.6,8.2-8.2v-46.2 h16.3v46.2c0,4.5,3.6,8.2,8.2,8.2h112.5l57.1,8.7c4,0.6,6.9,4,6.9,8.1V274.8z"
											/>
											<path
												d="M324.3,239.5h-10.9c-4.5,0-8.2,3.6-8.2,8.2s3.6,8.2,8.2,8.2h10.9c4.5,0,8.2-3.6,8.2-8.2S328.8,239.5,324.3,239.5z"
											/>
											<circle cx="242.8" cy="291.1" r="8.2" />
											<circle cx="438.4" cy="291.1" r="8.2" />
										</g>
									</g>
									<rect x="63.2" y="193.1" width="120.9" height="16.3" />
									<rect x="4" y="234.1" width="120.9" height="16.3" />
									<rect x="29.7" y="275.4" width="120.9" height="16.3" />
								</svg>
								<span class="mr-6"><b>Vendedores</b></span>
							</div>
						</div>
					</router-link>
				</div>
				<!-----------------------------------CLIENTES-------------------------------------------------------------->
				<div
					class="flex items-center justify-center mt-3 w-64 hover:bg-gray-500 hover:bg-opacity-25"
				>
					<router-link
						active-class="bg-gray-500 bg-opacity-25 opacity-100"
						to="/clientes"
						><div class="w-64 px-8">
							<div
								class="bg-center border-b border-black pb-0 w-48 flex items-center opacity-75 hover:opacity-100"
							>
								<svg
									class="fill-current text-black h-12 w-10 mb-2"
									version="1.1"
									id="Capa_1"
									xmlns="http://www.w3.org/2000/svg"
									xmlns:xlink="http://www.w3.org/1999/xlink"
									x="0px"
									y="0px"
									viewBox="0 0 477.869 477.869"
									style="enable-background: new 0 0 477.869 477.869"
									xml:space="preserve"
								>
									<g>
										<g>
											<path
												d="M387.415,233.496c48.976-44.029,52.987-119.424,8.958-168.4C355.991,20.177,288.4,12.546,239.02,47.332 c-53.83-37.99-128.264-25.149-166.254,28.68c-34.859,49.393-27.259,117.054,17.689,157.483 c-55.849,29.44-90.706,87.481-90.453,150.613v51.2c0,9.426,7.641,17.067,17.067,17.067h443.733 c9.426,0,17.067-7.641,17.067-17.067v-51.2C478.121,320.976,443.264,262.935,387.415,233.496z M307.201,59.842 c47.062-0.052,85.256,38.057,85.309,85.119c0.037,33.564-19.631,64.023-50.237,77.799c-1.314,0.597-2.628,1.143-3.959,1.707 c-4.212,1.699-8.556,3.051-12.988,4.045c-0.853,0.188-1.707,0.29-2.577,0.461c-4.952,0.949-9.977,1.457-15.019,1.519 c-2.27,0-4.557-0.171-6.827-0.375c-0.853,0-1.707,0-2.56-0.171c-9.7-1.142-19.136-3.923-27.904-8.226 c-0.324-0.154-0.7-0.137-1.024-0.273c-1.707-0.819-3.413-1.536-4.932-2.458c0.137-0.171,0.222-0.358,0.358-0.529 c7.826-10.056,13.996-21.296,18.278-33.297l0.529-1.434c1.947-5.732,3.459-11.602,4.523-17.562c0.154-0.87,0.273-1.707,0.41-2.645 c0.987-6.067,1.506-12.2,1.553-18.347c-0.049-6.135-0.568-12.257-1.553-18.313c-0.137-0.887-0.256-1.707-0.41-2.645 c-1.064-5.959-2.576-11.83-4.523-17.562l-0.529-1.434c-4.282-12.001-10.453-23.241-18.278-33.297 c-0.137-0.171-0.222-0.358-0.358-0.529C277.449,63.831,292.19,59.843,307.201,59.842z M85.335,145.176 c-0.121-47.006,37.886-85.21,84.892-85.331c22.034-0.057,43.232,8.434,59.134,23.686c0.99,0.956,1.963,1.911,2.918,2.901 c2.931,3.071,5.634,6.351,8.09,9.813c0.751,1.058,1.434,2.185,2.133,3.277c2.385,3.671,4.479,7.523,6.263,11.52 c0.427,0.973,0.751,1.963,1.126,2.935c1.799,4.421,3.215,8.989,4.233,13.653c0.12,0.512,0.154,1.024,0.256,1.553 c2.162,10.597,2.162,21.522,0,32.119c-0.102,0.529-0.137,1.041-0.256,1.553c-1.017,4.664-2.433,9.232-4.233,13.653 c-0.375,0.973-0.7,1.963-1.126,2.935c-1.786,3.991-3.88,7.837-6.263,11.503c-0.7,1.092-1.382,2.219-2.133,3.277 c-2.455,3.463-5.159,6.742-8.09,9.813c-0.956,0.99-1.929,1.946-2.918,2.901c-6.91,6.585-14.877,11.962-23.569,15.906 c-1.382,0.631-2.782,1.212-4.198,1.707c-4.114,1.633-8.347,2.945-12.663,3.925c-1.075,0.239-2.185,0.375-3.277,0.563 c-4.634,0.863-9.333,1.336-14.046,1.417h-1.877c-4.713-0.08-9.412-0.554-14.046-1.417c-1.092-0.188-2.202-0.324-3.277-0.563 c-4.316-0.98-8.55-2.292-12.663-3.925c-1.417-0.563-2.816-1.143-4.198-1.707C105.013,209.057,85.374,178.677,85.335,145.176z M307.201,418.242H34.135v-34.133c-0.25-57.833,36.188-109.468,90.76-128.614c29.296,12.197,62.249,12.197,91.546,0 c5.698,2.082,11.251,4.539,16.623,7.356c3.55,1.826,6.827,3.908,10.24,6.007c2.219,1.382,4.471,2.731,6.605,4.25 c3.294,2.338,6.4,4.881,9.455,7.492c1.963,1.707,3.908,3.413,5.751,5.12c2.816,2.662,5.461,5.478,8.004,8.363 c1.826,2.082,3.601,4.198,5.291,6.383c2.236,2.867,4.369,5.803,6.349,8.823c1.707,2.56,3.226,5.222,4.727,7.885 c1.707,2.935,3.277,5.871,4.71,8.926c1.434,3.055,2.697,6.4,3.925,9.66c1.075,2.833,2.219,5.649,3.106,8.533 c1.195,3.959,2.031,8.055,2.867,12.151c0.512,2.423,1.178,4.796,1.553,7.253c1.011,6.757,1.53,13.579,1.553,20.412V418.242z M443.735,418.242h-102.4v-34.133c0-5.342-0.307-10.633-0.785-15.872c-0.137-1.536-0.375-3.055-0.546-4.591 c-0.461-3.772-0.99-7.509-1.707-11.213c-0.307-1.581-0.631-3.169-0.973-4.762c-0.819-3.8-1.769-7.566-2.85-11.298 c-0.358-1.229-0.683-2.475-1.058-3.686c-4.779-15.277-11.704-29.797-20.565-43.127l-0.666-0.973 c-2.935-4.358-6.07-8.573-9.404-12.646l-0.119-0.154c-3.413-4.232-7.117-8.346-11.008-12.237c0.222,0,0.461,0,0.7,0 c4.816,0.633,9.666,0.975,14.524,1.024h0.939c4.496-0.039,8.985-0.33,13.449-0.87c1.399-0.171,2.782-0.427,4.181-0.649 c3.63-0.557,7.214-1.28,10.752-2.167c1.007-0.256,2.031-0.495,3.055-0.785c4.643-1.263,9.203-2.814,13.653-4.642 c54.612,19.127,91.083,70.785,90.829,128.649V418.242z"
											/>
										</g>
									</g>
								</svg>
								<span class="ml-10"><b>Clientes</b></span>
							</div>
						</div>
					</router-link>
				</div>
				<!-----------------------------------PEDIDOS--------------------------------------------------------------->
				<div
					class="flex items-center justify-center mt-3 w-64 hover:bg-gray-500 hover:bg-opacity-25"
				>
					<router-link
						active-class="bg-gray-500 bg-opacity-25 opacity-100"
						to="/pedidos"
						><div class="w-64 px-8">
							<div
								class="bg-center border-b border-black pb-0 w-48 flex items-center opacity-75 hover:opacity-100"
							>
								<svg
									class="fill-current text-black w-10 h-12 mb-2"
									id="Capa_1"
									enable-background="new 0 0 512 512"
									height="512"
									viewBox="0 0 512 512"
									width="512"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g>
										<path
											d="m361 29.578v-29.578h-210v29.578h-95v482.422h400v-482.422zm-180 .422h150v29.578h-150zm245 452h-340v-422.422h65v30h210v-30h65z"
										/>
										<path d="m206 124.578h-90v90h90zm-30 60h-30v-30h30z" />
										<path d="m255.875 154.578h140.125v30h-140.125z" />
										<path d="m206 248.578h-90v90h90zm-30 60h-30v-30h30z" />
										<path d="m255.875 278.578h140.125v30h-140.125z" />
										<path d="m255.875 400.578h140.125v30h-140.125z" />
										<path
											d="m149 415.365-19.394-19.393-21.212 21.213 40.606 40.606 65.606-65.606-21.212-21.213z"
										/>
									</g>
								</svg>
								<span class="ml-10"><b>Pedidos</b></span>
							</div>
						</div>
					</router-link>
				</div>
				<!-----------------------------------COTIZACIONES------------------------------------------------------------>
				<div
					class="flex items-center justify-center mt-3 w-64 hover:bg-gray-500 hover:bg-opacity-25"
				>
					<router-link
						active-class="bg-gray-500 bg-opacity-25 opacity-100"
						to="/cotizaciones"
						><div class="w-64 px-8">
							<div
								class="bg-center border-b border-black pb-0 w-48 flex items-center opacity-75 hover:opacity-100"
							>
								<svg
									class="fill-current text-black w-10 h-12 mb-2"
									id="Capa_1"
									enable-background="new 0 0 551.13 551.13"
									height="512"
									viewBox="0 0 551.13 551.13"
									width="512"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="m275.565 0c-151.944 0-275.565 123.621-275.565 275.565s123.621 275.565 275.565 275.565 275.565-123.621 275.565-275.565-123.621-275.565-275.565-275.565zm0 516.685c-132.955 0-241.119-108.164-241.119-241.119s108.164-241.12 241.119-241.12 241.12 108.164 241.12 241.119-108.165 241.12-241.12 241.12z"
									/>
									<path
										d="m292.788 137.783h-34.446v120.56h-120.56v34.446h120.56v120.56h34.446v-120.56h120.56v-34.446h-120.56z"
									/>
								</svg>
								<span class="ml-10"><b>Cotizaciones</b></span>
							</div>
						</div>
					</router-link>
				</div>
				<!-----------------------------------PRODUCTOS------------------------------------------------------------>
				<div
					class="flex items-center justify-center mt-3 mb-30 w-64 hover:bg-gray-500 hover:bg-opacity-25"
				>
					<router-link
						active-class="bg-gray-500 bg-opacity-25 opacity-100"
						to="/productos"
						><div class="w-64 px-8">
							<div
								class="bg-center border-b border-black pb-0 w-48 flex items-center opacity-75 hover:opacity-100"
							>
								<svg
									class="fill-current text-black w-12 h-12 mb-2"
									enable-background="new 0 0 24 24"
									height="512"
									viewBox="0 0 24 24"
									width="512"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="m16.5 10h-9c-.276 0-.5-.224-.5-.5v-9c0-.276.224-.5.5-.5h9c.276 0 .5.224.5.5v9c0 .276-.224.5-.5.5zm-8.5-1h8v-8h-8z"
									/>
									<path
										d="m13.5 4h-3c-.276 0-.5-.224-.5-.5v-3c0-.276.224-.5.5-.5h3c.276 0 .5.224.5.5v3c0 .276-.224.5-.5.5zm-2.5-1h2v-2h-2z"
									/>
									<path
										d="m12 19h-9.5c-.276 0-.5-.224-.5-.5v-9c0-.276.224-.5.5-.5h9.5c.276 0 .5.224.5.5v9c0 .276-.224.5-.5.5zm-9-1h8.5v-8h-8.5z"
									/>
									<path
										d="m8.5 13h-3c-.276 0-.5-.224-.5-.5v-3c0-.276.224-.5.5-.5h3c.276 0 .5.224.5.5v3c0 .276-.224.5-.5.5zm-2.5-1h2v-2h-2z"
									/>
									<path
										d="m21.5 19h-9.5c-.276 0-.5-.224-.5-.5v-9c0-.276.224-.5.5-.5h9.5c.276 0 .5.224.5.5v9c0 .276-.224.5-.5.5zm-9-1h8.5v-8h-8.5z"
									/>
									<path
										d="m18.5 13h-3c-.276 0-.5-.224-.5-.5v-3c0-.276.224-.5.5-.5h3c.276 0 .5.224.5.5v3c0 .276-.224.5-.5.5zm-2.5-1h2v-2h-2z"
									/>
									<path
										d="m23.5 24h-4c-.276 0-.5-.224-.5-.5v-1.5h-4v1.5c0 .276-.224.5-.5.5h-5c-.276 0-.5-.224-.5-.5v-1.5h-4v1.5c0 .276-.224.5-.5.5h-4c-.276 0-.5-.224-.5-.5v-5c0-.276.224-.5.5-.5h23c.276 0 .5.224.5.5v5c0 .276-.224.5-.5.5zm-3.5-1h3v-4h-22v4h3v-1.5c0-.276.224-.5.5-.5h5c.276 0 .5.224.5.5v1.5h4v-1.5c0-.276.224-.5.5-.5h5c.276 0 .5.224.5.5z"
									/>
								</svg>
								<span class="ml-8"><b>Productos</b></span>
							</div>
						</div>
					</router-link>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import arrow from "@/components/arrow.vue";
import close from "@/components/close.vue";
export default {
	name: "Sidebar",
	components: {
		arrow,
		close
	},
	data() {
		return {
			sideMenu: false
		};
	}
};
</script>

<style scoped>
.menu-side-bar-enter-active {
	transition: all 0.3s;
}
.menu-side-bar-leave-active {
	transition: all 0.5s;
}
.menu-side-bar-enter,
.menu-side-bar-leave-to {
	transform: translateX(-60rem);
	opacity: 0;
	height: 0%;
}
</style>
